/* global modalpromo */


import barba from '@barba/core'
import Cookies from 'js-cookie'
import 'modaal/dist/js/modaal'
import { gsap } from 'gsap'
import throttle from 'lodash/throttle'
import AOS from 'aos'
import LazyLoad from 'vanilla-lazyload'



export const lazySelector = new LazyLoad({
    elements_selector: '.data-load-img',
})


export default {
    fullMenu(){
        const app = this
        let sctollTop_length = 0

        const checkScreenSizeEffects = () => {
            if($(window).width() < 1024){
                gsap.set('.column-header-menu', { x: '0px', opacity: 1 })
                gsap.set('.main-link-menu', { y: '0px', opacity: 1 })
            }
        }

        const throttledEffects = throttle(checkScreenSizeEffects, 300)

        $(window).on('resize', throttledEffects)

        const checkDelay = () => {
            if($(window).width() < 1024){
                return false
            }
            return true
        }

        const tlOpen = gsap.timeline({
            paused: true,
            onStart: function () {
                app.burger()
                $(document.body).css('overflow', 'hidden')
                sctollTop_length = $(window).scrollTop()

                if(checkDelay()){
                    gsap.set('.column-header-menu', { x: '-70px', opacity: 0 })
                    gsap.set('.main-link-menu', { y: '20px', opacity: 0 })
                }


                if(checkDelay()){

                    gsap.to('.main-link-menu', 0.7, {
                        y: '0px',
                        opacity: 1,
                        delay: 0.2,
                        stagger: 0.05,
                    })


                    gsap.to('.column-header-menu', 0.55, {
                        opacity: 1,
                        x: '0px',
                        delay: 0.75,
                        stagger: 0.35,
                    })
                }

            },
        })
            .set('.header-app__fullmenu', { opacity: 1, y: '-100%', visibility: 'visible' })
            .to('.header-app__fullmenu', 0.4, {
                y: '0%',
                ease: 'power3.out',
                onComplete: function() {
                    tlOpen.set('.header-app__fullmenu', { pointerEvents: 'auto' })
                    $('.header-app__logo').addClass('show-top-bottom')
                },

            }, 0)

            if(checkDelay()){
                tlOpen.from('.header-app__fullmenu__image-container', 0.4, { opacity: 0, y: '-20%', ease: 'power3.out' }, 0.15)
            }

        const tlClose = gsap.timeline({
            paused: true,
            onStart: () => {
                app.burger()

            },
            onComplete: function() {
                $(document.body).css('overflow', 'auto')
                $(window).scrollTop(sctollTop_length)

                $('.header-app__logo').removeClass('show-top-bottom')
                if(checkDelay()){
                    gsap.set('.main-link-menu', { y: '20px', opacity: 0 })
                    gsap.set('.column-header-menu',{ x: '-70px', opacity: 0 })
                }
            },
        })
            tlClose.set('.header-app__fullmenu', { pointerEvents: 'none' })
            tlClose.to('.header-app__fullmenu', 0.4, {
                opacity: 0,
                ease: 'power3.out',
                onComplete: function() {
                    if(checkDelay()){
                        tlClose.set('.header-app__fullmenu__image-container', { opacity: 0, y: '-100%' })
                    }
                },
            }, 0)






        $(document.body).on('click','button.hamburger',function(e){
            e.preventDefault()
            if($(this).hasClass('is-active')){


                $(this).removeClass('is-active')
                if(!tlClose.isActive()){
                    tlClose.restart()
                }
                if(tlOpen.isActive()){
                    tlOpen.pause()
                }
                tlClose.play()


            } else {

                $(this).addClass('is-active')

                if(!tlOpen.isActive()){
                    tlOpen.restart()
                }
                if(tlClose.isActive()){
                    tlClose.pause()
                }
                tlOpen.play()

            }
        })
        $(document.body).keyup(function(e) {
          if (e.keyCode === 27 && $('.hamburger').hasClass('is-active')){
                $('.hamburger').removeClass('is-active')
                if(!tlClose.isActive()){
                    tlClose.restart()
                }
                if(tlOpen.isActive()){
                    tlOpen.pause()
                }
                tlClose.play()
          }

        });
        $(document.body).on('click', '.link-menu-app, .header-app__logo', function() {
          if ($('.hamburger').hasClass('is-active')){
                $('.hamburger').removeClass('is-active')
                if(!tlClose.isActive()){
                    tlClose.restart()
                }
                if(tlOpen.isActive()){
                    tlOpen.pause()
                }
                tlClose.play()
          }

        })
    },
    burgerSettings: { interacted: !1, animating: !1 },
    burger(){
            const app = this
            function t(e) {
                var i = e.parentNode;
                if ("svg" !== i.tagName) i = t(i);
                return i;
            }
            function e(t, e, i, n) {
                return 1 > (t /= n / 2) ? (i / 2) * t * t * t * t + e : (-i / 2) * ((t -= 2) * t * t * t - 2) + e;
            }
            function i(t) {
                (this.element = t),
                    (this.topLine = this.element.getElementsByTagName("path")[0]),
                    (this.centerLine = this.element.getElementsByTagName("path")[1]),
                    (this.bottomLine = this.element.getElementsByTagName("path")[2]),
                    (this.time = { start: null, total: 250 }),
                    this.init();
            }
            if (!window.requestAnimationFrame) {
                var n = null;
                window.requestAnimationFrame = function (t, e) {
                    var i = new Date().getTime();
                    n || (n = i);
                    var a = Math.max(0, 16 - (i - n)),
                        s = window.setTimeout(function () {
                            t(i + a);
                        }, a);
                    return (n = i + a), s;
                };
            }
            (i.prototype.init = function () {
                var t = this;
                app.burgerSettings.animating || ((app.burgerSettings.animating = !0), window.requestAnimationFrame(t.triggerAnimation.bind(t)));
            }),
                (i.prototype.triggerAnimation = function (t) {
                    var e = this.getProgress(t),
                        i = app.burgerSettings.interacted ? this.time.total - e : e;
                    this.animateIcon(i), this.checkProgress(e);
                }),
                (i.prototype.getProgress = function (t) {
                    return this.time.start || (this.time.start = t), t - this.time.start;
                }),
                (i.prototype.checkProgress = function (t) {
                    var e = this;
                    this.time.total > t ? window.requestAnimationFrame(e.triggerAnimation.bind(e)) : ((app.burgerSettings = { interacted: !app.burgerSettings.interacted, animating: !1 }), (this.time.start = null));
                }),
                (i.prototype.animateIcon = function (t) {
                    if (t > this.time.total) t = this.time.total;
                    if (0 > t) t = 0;
                    var i = e(Math.min(t, this.time.total / 2), 0, 10, this.time.total / 2).toFixed(2),
                        n = e(Math.max(t - this.time.total / 2, 0), 0, 45, this.time.total / 2).toFixed(2);
                    this.topLine.setAttribute("transform", "translate(0 " + i + ") rotate(" + n + " 16 6)"), this.bottomLine.setAttribute("transform", "translate(0 " + -i + ") rotate(" + -n + " 16 26)");
                    var a = t > this.time.total / 2 ? 0 : 1;
                    this.centerLine.setAttribute("opacity", a);
                });
            var a = document.getElementsByClassName("nc-interact_menu-close-2-o-32");
            if (a) for (var s = 0; a.length > s; s++) new i(t(a[s]));
    },
    animationsCommon() {
        AOS.init({
            anchorPlacement: 'center-bottom',
            duration: 700,
            easing: 'outexpo',
            delay: 100,
            once: true,
        })
    },
    modalPromo(){
        if(modalpromo.active){
            $('.modal-promo').modaal({
                after_close: () => {
                    if(modalpromo.cookies){
                        Cookies.set('modalpromo', 'closed', { expires: modalpromo.expires });
                    }
                },
            })

            if(!modalpromo.postcode){
                if(modalpromo.cookies){
                    if(Cookies.get('modalpromo') !== 'closed'){
                        $('.modal-promo').modaal('open')
                    }

                } else {
                    $('.modal-promo').modaal('open')
                }
            }

            $(document.body).on('click', '.link-inner-promo-modal', function(){
                $('.modal-promo').modaal('close')
            })

        }

    },

    cookiesPopup() {
        if(Cookies.get('cookie') !== 'accept'){
            $('#cookies').addClass('show');
        }
        $(document.body).on('click', '#btnCloseCookie', function(e){
            e.preventDefault()
            Cookies.set('cookie', 'accept');
            $('#cookies').removeClass('show');
        })

    },
    init() {
        this.fullMenu()
        this.animationsCommon()
        this.cookiesPopup()
        this.modalPromo()
    },

}
